import React from "react";
import { observer } from "mobx-react";

import { TSuggestedEvent } from "@data-types/suggested-search/SuggestedEvent";

import { useRootAppStore } from "@hooks";
import { SearchAction } from "@state/stores/offer/search/SearchStore";
import { SuggestedEventTeamDisplay } from "./SuggestedEventTeamDisplay";
import OfferIcons from "@components/icons/Offer";
import { useFormContext } from "react-hook-form";

export const SuggestedListEvent = observer(function SuggestedListEvent(props: {
	item: TSuggestedEvent;
}) {
	const store = useRootAppStore().searchStore;
	const form = useFormContext();

	return (
		<li
			className="popup--search__item"
			onClick={() => {
				const searchResult = store.searchSuggestedItem(
					SearchAction.EVENT_PICK,
					{
						displayText: store.searchTerm,
						eventId: props.item.eventId,
					}
				);

				if (searchResult) {
					form.reset();
				}

				store.setIsSuggestedListOpen(false);
			}}
		>
			<div className="popup--search__thumbs">
				<OfferIcons
					type="sport"
					sport={props.item.sport.abrv || ""}
					wrapperClassName="popup--search__icon popup--search__sport u-icon u-icon--med"
					className="popup--search__icon__inner u-icon--base"
				/>

				<OfferIcons
					type="tournament"
					sport={props.item.sport.abrv}
					category={props.item.category?.abrv || ""}
					tournament={props.item.tournament?.abrv || ""}
					wrapperClassName="popup--search__icon popup--search__trophy u-icon u-icon--med"
					className="popup--search__icon__inner u-icon--base"
				/>
			</div>
			<div className="popup--search__name">
				<SuggestedEventTeamDisplay
					t1={props.item.teamOne}
					t2={props.item.teamTwo}
					tournament={props.item.tournament}
				/>
				<span className="popup--search__team__divider">-</span>
				<SuggestedEventTeamDisplay
					t1={props.item.teamTwo}
					t2={props.item.teamOne}
					tournament={props.item.tournament}
				/>
			</div>
		</li>
	);
});
